import {
  provideTransloco,
  TranslocoModule,
  TRANSLOCO_FALLBACK_STRATEGY
} from '@jsverse/transloco';
import { NgModule } from '@angular/core';
import { TranslocoBundledLoader } from './transloco-bundled-loader';
import { environment } from 'src/environments/environment';
import { LanguageConstants } from './utils/constants/language.constants';
import { LanguageFallbackStrategyService } from './services/i18n/language-fallback-strategy.service';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: LanguageConstants.SUPPORTED_LANGUAGE_CODES,
        defaultLang: LanguageConstants.DEFAULT_LANGUAGE_CODE,
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
        missingHandler: {
          logMissingKey: false,
          useFallbackTranslation: true
        }
      },
      loader: TranslocoBundledLoader
    }),
    { provide: TRANSLOCO_FALLBACK_STRATEGY, useClass: LanguageFallbackStrategyService },
  ],
})
export class TranslocoRootModule { }
